module.exports = __webpack_public_path__ + "static/media/generic_avatar.3845b830.svg";